import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";

export function getEnvironmentConfig() {
  const hostname = typeof window !== "undefined" ? window.location.hostname : "localhost";
  const hostedEnvironment =
    hostname.includes("tennis-uploader-stg") || hostname.includes("stg")
      ? "stg"
      : hostname.includes("tennis-uploader-dev") || hostname.includes("localhost")
        ? "dev"
        : hostname === "tennis-uploader.web.app"
          ? "prod"
          : null;
  const envName = hostedEnvironment || process.env.REACT_APP_ENV || "prod";

  const authDomainByEnv = {
    dev: hostname === "localhost" ? "localhost" : "tennis-uploader-dev.firebaseapp.com",
    stg: hostname === "localhost" ? "localhost" : "tennis-uploader-stg.firebaseapp.com",
    prod: hostname === "localhost" ? "localhost" : "tennis-uploader.firebaseapp.com",
  };

  const configs = {
    dev: {
      apiKey: process.env.REACT_APP_FIREBASE_API_KEY_DEV || "AIzaSyAEOJTy1QvfLHik27bDOmsV4h4KCbQzoLE",
      authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_DEV || authDomainByEnv.dev,
      projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_DEV || "tennis-uploader-dev",
      storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_DEV || "tennis-uploader-serve-dev.appspot.com",
      messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_DEV || "183718313912",
      appId: process.env.REACT_APP_FIREBASE_APP_ID_DEV || "1:183718313912:web:316cab20da23edb121594d",
      measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_DEV || "G-CNWXY46J5E",
      bucket: process.env.REACT_APP_FIREBASE_BUCKET_DEV || "tennis-uploader-serve-dev",
    },
    stg: {
      apiKey: process.env.REACT_APP_FIREBASE_API_KEY_STG || "AIzaSyBRHMOIEByteXiwTasf-lVCEa1rEOsMfdU",
      authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_STG || authDomainByEnv.stg,
      projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_STG || "tennis-uploader-stg",
      storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_STG || "tennis-uploader-stg.firebasestorage.app",
      messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_STG || "124688260416",
      appId: process.env.REACT_APP_FIREBASE_APP_ID_STG || "1:124688260416:web:4ae8680ec08820c1746ea5",
      measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_STG || "G-RFCCM1LV41",
      bucket: process.env.REACT_APP_FIREBASE_BUCKET_STG || "tennis-uploader-serve-stg",
    },
    prod: {
      apiKey: process.env.REACT_APP_FIREBASE_API_KEY_PROD || "AIzaSyAEOJTy1QvfLHik27bDOmsV4h4KCbQzoLE",
      authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN_PROD || authDomainByEnv.prod,
      projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_PROD || "tennis-uploader",
      storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_PROD || "tennis-uploader.firebasestorage.app",
      messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID_PROD || "183718313912",
      appId: process.env.REACT_APP_FIREBASE_APP_ID_PROD || "1:183718313912:web:1726fe2ba75c665321594d",
      measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_PROD || "G-GWTCM5GP4W",
      bucket: process.env.REACT_APP_FIREBASE_BUCKET_PROD || "tennis-uploader-serve",
    },
  };

  const resolvedConfig = configs[envName] || configs.prod;

  if (
    typeof window !== "undefined" &&
    (!resolvedConfig.apiKey || !resolvedConfig.appId || !resolvedConfig.messagingSenderId || !resolvedConfig.projectId)
  ) {
    console.warn("Firebase config is incomplete for environment:", envName, resolvedConfig);
  }

  return resolvedConfig;
}

const app = initializeApp(getEnvironmentConfig());

export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
provider.addScope("email");
provider.setCustomParameters({ prompt: "select_account" });

export async function signInWithGoogle() {
  console.log("signInWithGoogle start", {
    hostname: typeof window !== "undefined" ? window.location.hostname : "unknown",
    authDomain: auth.config ? auth.config.authDomain : "unknown",
    projectId: auth.config ? auth.config.projectId : "unknown",
    provider: provider.providerId,
  });

  try {
    const result = await signInWithPopup(auth, provider);
    console.log("Google sign-in success", result.user?.email, result.user?.uid);
    return result;
  } catch (error) {
    console.error("Google sign-in failed", error);

    if (
      error?.code === "auth/popup-blocked" ||
      error?.code === "auth/popup-closed-by-user" ||
      error?.code === "auth/cancelled-popup-request"
    ) {
      window.alert("Please allow pop-ups for this site and click Continue with Google again.");
      return;
    }

    if (error?.code === "auth/invalid-continue-uri") {
      window.alert("Google sign-in is still misconfigured. Please check the Firebase auth domain and OAuth redirect URIs.");
      return;
    }

    window.alert("Google sign-in failed. Please check the Firebase auth configuration and try again.");
  }
}

export { signOut };
